import React from "react";
import NetworkTab from "./Elements/NetworkTab";
import { isOnboardingPremiumNetwork } from "../../../../../../utils";

class SelectSource extends React.Component {

    updatedSelectedSource = (networkId) => {
        const { updatedSelectedNetwork, updateStep } = this.props;
        updatedSelectedNetwork(networkId);
        // premium network: stay on this step, the chat shows the upgrade message instead
        if (!isOnboardingPremiumNetwork(networkId)) setTimeout(() => updateStep(1), 100);
    }

    render() {
        const { selectedNetworkId, stepCompleted, networkList, hasSelectedNetworkOnce, networkError, onRetryNetworks } = this.props;

        return stepCompleted == 0 ? (
            <div className={`ob-panel-body panel-body-p${hasSelectedNetworkOnce ? ' ob-no-intro-anim' : ''}`}>
                <h4 className="ob-panel-title">Select preferred network type</h4>
                <p className="ob-panel-subtitle">Select the social platform from which you want to add the feeds</p>

                <ul className="ob-source-grid d-flex flex-wrap">
                    {networkList.length > 0 ? networkList.map(network => <NetworkTab network={network} selectedNetworkId={selectedNetworkId} updatedSelectedNetwork={this.updatedSelectedSource} key={network.networkId} />)
                        : networkError ? (
                            <li className="ob-source-status">
                                <p>Couldn't load networks. Please try again.</p>
                                <button type="button" className="ob-btn-gradient" onClick={onRetryNetworks}>Retry</button>
                            </li>
                        )
                            // still loading (or about to start) - placeholder tiles instead of an empty panel
                            : Array.from({ length: 12 }, (_, i) => (
                                <li className="ob-source-tile ob-source-tile-skeleton" key={i}>
                                    <div className="ob-skeleton-icon"></div>
                                    <div className="ob-skeleton-text"></div>
                                </li>
                            ))}
                </ul>
            </div>
        ) : null;
    }
}

export default SelectSource;
